module.exports = __webpack_public_path__ + "static/media/hide.6a9fe2e5.svg";